<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vVxEt/tc-custom/9781631950162.jpg?1728851662289" alt="This image is the cover for the book From Broken to Beautiful"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Broken to Beautiful
      </h1>
      <p class="bookDescription body article font2">
        <b>A step-by-step journey to help you discover your truth, let go of fear, and dig you and your spouse out of the deepest of relationship ruts.</b><br/><br/><i>From Broken to Beautiful</i> shows women how to adjust their communication with their husbands in order for them to have the relationship they truly desire. It walks women through Sarah Jane Patton’s real-life triumphs and tribulations that led her to healing and happiness. After reading <i>From Broken to Beautiful</i>, women and their husbands will:Talk again every day with ease, like they used toGo on dates and fall in love all over againHelp each other understand one another’s feelings without arguingSave their marriage from ending in divorce
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Jane Patton
      </h2>
      
      <p class="authorDescription body article"><B>Sarah Jane Patton</B> is the author of <I>From Broken to Beautiful: 9 Secrets That Will Transform Your Marriage</I>. She coaches women who are struggling with their relationships by helping them discover their self-worth and focus on self-love. Sarah has a passion for helping women in need and is committed to continuing her work in personal development. She is the founder of the OLSON Foundation, a not for profit organization that provides funding for women in need. She resides in the suburbs of St. Louis, Missouri, with her husband and eight children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25a23d16